import { safeStorage } from '@/App';

// Attribution first-party: ID pelawat kekal + satu beacon setiap sesi (referrer, UTM, /go/ slug, landing page).
const KEY_VID = 'flexa_vid';
const KEY_SESS = 'flexa_sess_tracked';
export const KEY_GO = 'flexa_go';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

const uuid = () => (window.crypto?.randomUUID ? crypto.randomUUID()
  : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => { const r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16); }));

export function getVisitorId() {
  let v = safeStorage.get(KEY_VID);
  if (!v) { v = uuid(); safeStorage.set(KEY_VID, v); }
  return v;
}

const session = {
  get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
  set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* disekat */ } },
};

export const rememberGo = (slug, to) => session.set(KEY_GO, JSON.stringify({ slug, to }));

export function trackVisit() {
  if (session.get(KEY_SESS)) return;
  session.set(KEY_SESS, '1');
  const url = new URL(window.location.href);
  const utm = {};
  UTM_KEYS.forEach(k => { const v = url.searchParams.get(k); if (v) utm[k] = v.slice(0, 100); });
  let go = null;
  try { go = JSON.parse(session.get(KEY_GO) || 'null'); } catch (e) { /* ignore */ }
  const body = JSON.stringify({
    vid: getVisitorId(),
    path: go?.to && url.pathname.startsWith('/go/') ? go.to : url.pathname,
    referrer: document.referrer || '',
    utm, go: go?.slug || null, w: window.innerWidth,
  });
  const endpoint = `${process.env.REACT_APP_BACKEND_URL}/api/track/visit`;
  if (navigator.sendBeacon && navigator.sendBeacon(endpoint, new Blob([body], { type: 'application/json' }))) return;
  fetch(endpoint, { method: 'POST', body, headers: { 'Content-Type': 'application/json' }, keepalive: true }).catch(() => {});
}

// Jalankan selepas page siap dimuat supaya tidak bersaing dengan render/LCP
export function scheduleTrackVisit() {
  const run = () => setTimeout(trackVisit, 400);
  if (document.readyState === 'complete') run(); else window.addEventListener('load', run, { once: true });
}
